import { logo } from "../services/index.path";
export class MarkerModel{
    id?:number;
    latitude_event?:number;
    longitude_event?:number;
    title?:string;
    file?:string;

    constructor(id:number,lat:number,lng:number,title:string,file:string){
        this.id = id;
        this.latitude_event = lat;
        this.longitude_event = lng;
        this.title = title;
        if(String(file).includes(".undef")) this.file = logo;
        else this.file = file;
    }
}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/models/marker.model.ts